import { FilterList, ResultsData } from "../../../app/bus/results/types";
import { Types, NoResultsFound, GovtBuses, SelectedFilters } from "./types";

export const setResultsData = (
  payload: ResultsData
): {
  type: Types.SET_RESULTS_DATA;
  payload: ResultsData;
} => ({
  type: Types.SET_RESULTS_DATA,
  payload,
});

export const setResultsLoading = (
  payload: boolean
): {
  type: Types.SET_RESULTS_LOADING;
  payload: boolean;
} => ({
  type: Types.SET_RESULTS_LOADING,
  payload,
});

export const setListOptions = (payload: {
  amenities: FilterList[];
  pickupPoints: FilterList[];
  dropOffPoints: FilterList[];
  busOperators: FilterList[];
}): {
  type: Types.SET_FILTERS_WITH_OPTIONS;
  payload: {
    amenities: FilterList[];
    pickupPoints: FilterList[];
    dropOffPoints: FilterList[];
    busOperators: FilterList[];
  };
} => ({
  type: Types.SET_FILTERS_WITH_OPTIONS,
  payload,
});

export const applyFilters = (payload: {
  newFilterResults: ResultsData;
  newFilteredGovtBuses: GovtBuses;
  newFilterList: Record<string, FilterList[]>;
}): {
  type: Types.APPLY_FILTERS;
  payload: {
    newFilterResults: ResultsData;
    newFilteredGovtBuses: GovtBuses;
    newFilterList: Record<string, FilterList[]>;
  };
} => ({
  type: Types.APPLY_FILTERS,
  payload,
});

export const setshowFilters = (
  payload: null
): { type: Types.SET_SHOW_FILTERS; payload: null } => ({
  type: Types.SET_SHOW_FILTERS,
  payload,
});

export const setNoResultsFound = (
  payload: NoResultsFound
): { type: Types.NO_RESULTS_FOUND; payload: NoResultsFound } => ({
  type: Types.NO_RESULTS_FOUND,
  payload,
});

export const setFilterList = (
  payload: Record<string, any>
): { type: Types.SET_FILTER_LIST; payload: Record<string, any> } => ({
  type: Types.SET_FILTER_LIST,
  payload,
});

export const setGovtBuses = (
  payload: GovtBuses
): { type: Types.SET_GOVT_BUSES; payload: GovtBuses } => ({
  type: Types.SET_GOVT_BUSES,
  payload,
});

export const setSelectedFilters = (
  payload: SelectedFilters
): {
  type: Types.SET_SELECTED_FILTERS;
  payload: SelectedFilters;
} => ({
  type: Types.SET_SELECTED_FILTERS,
  payload,
});

export const clearContextData = (
  payload: null
): { type: Types.CLEAR_CONTEXT_DATA; payload: null } => ({
  type: Types.CLEAR_CONTEXT_DATA,
  payload,
});

export const setShowSeatLayout = (
  payload: boolean
): {
  type: Types.SET_SHOW_SEAT_LAYOUT;
  payload: boolean;
} => ({
  type: Types.SET_SHOW_SEAT_LAYOUT,
  payload,
});

export type Action =
  | ReturnType<typeof setResultsData>
  | ReturnType<typeof setListOptions>
  | ReturnType<typeof applyFilters>
  | ReturnType<typeof setshowFilters>
  | ReturnType<typeof setNoResultsFound>
  | ReturnType<typeof setGovtBuses>
  | ReturnType<typeof clearContextData>
  | ReturnType<typeof setFilterList>
  | ReturnType<typeof setSelectedFilters>
  | ReturnType<typeof setResultsLoading>
  | ReturnType<typeof setShowSeatLayout>;
